/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkWaterBottleIcon16Light } from './FoodDrinkWaterBottleIcon16Light';
import { FoodDrinkWaterBottleIcon16Regular } from './FoodDrinkWaterBottleIcon16Regular';
import { FoodDrinkWaterBottleIcon16Solid } from './FoodDrinkWaterBottleIcon16Solid';
import { FoodDrinkWaterBottleIcon20Light } from './FoodDrinkWaterBottleIcon20Light';
import { FoodDrinkWaterBottleIcon20Regular } from './FoodDrinkWaterBottleIcon20Regular';
import { FoodDrinkWaterBottleIcon20Solid } from './FoodDrinkWaterBottleIcon20Solid';
import { FoodDrinkWaterBottleIcon24Regular } from './FoodDrinkWaterBottleIcon24Regular';
import { FoodDrinkWaterBottleIcon24Solid } from './FoodDrinkWaterBottleIcon24Solid';
import { FoodDrinkWaterBottleIcon32Regular } from './FoodDrinkWaterBottleIcon32Regular';
import { FoodDrinkWaterBottleIcon64Regular } from './FoodDrinkWaterBottleIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkWaterBottleIcon16Light,
        regular: FoodDrinkWaterBottleIcon16Regular,
        solid: FoodDrinkWaterBottleIcon16Solid,
    },
    20: {
        light: FoodDrinkWaterBottleIcon20Light,
        regular: FoodDrinkWaterBottleIcon20Regular,
        solid: FoodDrinkWaterBottleIcon20Solid,
    },
    24: {
        regular: FoodDrinkWaterBottleIcon24Regular,
        solid: FoodDrinkWaterBottleIcon24Solid,
    },
    32: {
        regular: FoodDrinkWaterBottleIcon32Regular,
    },
    64: {
        regular: FoodDrinkWaterBottleIcon64Regular,
    },
};
export var FoodDrinkWaterBottleIcon = forwardRef('FoodDrinkWaterBottleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
